<template>
    <div class="max-w-screen-xl mx-auto mt-12 md:mt-18 lg:mt-20 xl:mt-24 md:mb-18 mb-12 px-4">
        <div>
            <h2 class="text-center mx-auto max-w-6xl text-2xl sm:text-3xl lg:text-4xl font-medium mb-10">
                <span class="down-mark-line">
                   {{ customize.title }}
                </span>
            </h2>
            <p class="text-lg md:text-xl text-center">
                {{ customize.description }}
            </p>
            <div class="mt-12 gap-4 grid grid-cols-12">
                <div v-for="d in customize.data" class="xl:col-span-4 md:col-span-6 col-span-12">
                    <div class="flex flex-col justify-center items-center text-center">
                        <nuxt-img :src="'/home/'+d.icon" format="webp" :alt="d.title" :loading="'lazy'"></nuxt-img>
                        <h3 class="font-semibold text-2xl mb-6 mt-3">{{ d.title }}</h3>
                        <p>{{ d.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import OwnerSystemLocale from '~~/config/widgets/owner-system';

const customize = (new OwnerSystemLocale)
</script>
  